/** Distinct values of a field, most used first: suggestions for locations, stores, units. */
export function rankSuggestions<T>(rows: readonly T[], pick: (row: T) => string | undefined): string[] {
  const counts = new Map<string, number>();
  for (const row of rows) {
    const value = pick(row)?.trim();
    if (value) counts.set(value, (counts.get(value) ?? 0) + 1);
  }
  return [...counts.entries()].sort((a, b) => b[1] - a[1]).map(([value]) => value);
}
